var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debounce, once } from "lodash";
import { campaignComponentChangeEvent, campaignComponentDeletedEvent, campaignComponentListChangeEvent, } from "../../event-bus/campaign-component";
import { useBuiltCampaign } from "../../campaign-built/composables";
import { until } from "@vueuse/core";
import { useCampaignStore } from "..";
const AUTO_PUBLISH_CAMPAIGN_TYPES = [
    "INTEGRATION",
    "EXTENSION",
];
const start = once(() => {
    const campaignStore = useCampaignStore();
    const autoPublishAndLaunchCampaign = debounce((campaignId) => __awaiter(void 0, void 0, void 0, function* () {
        const { builtCampaign } = useBuiltCampaign(campaignId);
        yield until(builtCampaign).toBeTruthy();
        if (builtCampaign.value &&
            AUTO_PUBLISH_CAMPAIGN_TYPES.includes(builtCampaign.value.campaign_type)) {
            try {
                yield campaignStore.publishDraft(campaignId, {
                    message: null,
                    launch: false,
                });
                if (builtCampaign.value.state === "NOT_LAUNCHED") {
                    yield campaignStore.launchTest(campaignId);
                }
            }
            catch (e) {
                console.error("Your changes could not be published");
            }
        }
    }), 3000);
    campaignComponentChangeEvent.on((event) => __awaiter(void 0, void 0, void 0, function* () {
        autoPublishAndLaunchCampaign(event.campaignId);
    }));
    campaignComponentListChangeEvent.on((event) => __awaiter(void 0, void 0, void 0, function* () {
        autoPublishAndLaunchCampaign(event.campaignId);
    }));
    campaignComponentDeletedEvent.on((event) => __awaiter(void 0, void 0, void 0, function* () {
        autoPublishAndLaunchCampaign(event.campaignId);
    }));
});
export default {
    start,
};
